// extracted by mini-css-extract-plugin
module.exports = {"container":"EditMetaverseAdvancedSettings_container__hni9E","setting":"EditMetaverseAdvancedSettings_setting__HUNgh","label":"EditMetaverseAdvancedSettings_label__2Rzbo"};